import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { motion } from 'framer-motion';
import "./styles.scss";
import { GET_RANKING } from "services/GamificacaoService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faTrophy } from "@fortawesome/free-solid-svg-icons";

const CardInfo = ({ title, text, img, link, textBtn, isloading }) => {

  const [ranking, setRanking] = useState(null); // Set initial state to null
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    // Limpa o listener ao desmontar o componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchRanking = async () => {
      const data = await GET_RANKING();
      setRanking(data.value);
    };
    fetchRanking();
  }, []);

  const isRanking = ranking && ranking.totalQuestoesRespondidas > 0;
  const rankingTop = ranking && ranking.percentualTop > 0 ? ranking.percentualTop : 1;


  return (
    <Card className="card-box">
      <Card.Body className="card__content">
        {isloading ? (
          <span className="d-flex align-items-center justify-content-center">Carregando...</span>

        ) : (
          <>
            <Card.Title className="card-box__title">{title}</Card.Title>
            <Card.Text className="card-box__description">{text}</Card.Text>
            <Link to={link} className="btn btn-primary card-box__button">
              {textBtn}
            </Link>


            <div className="gamification-container-card">
              <motion.span
                className="card-gaming"
                initial={{ opacity: 0, x: -20 }} // 
                animate={{ opacity: 1, x: 0 }}   // Anima para ficar visível e na posição original
                transition={{ duration: 1 }}    // Duração da animação
              >
                <FontAwesomeIcon icon={faStar} className="gamification-icon me-2" />
                {ranking && (
                  <Card.Text>
                    {ranking.totalQuestoesRespondidas === 0
                      ? "Você ainda não respondeu nenhum exercício."
                      : isMobile
                        ? `${ranking.totalQuestoesRespondidas} exercícios.`
                        : `Você completou ${ranking.totalQuestoesRespondidas} exercícios.`}
                  </Card.Text>
                )}
              </motion.span>

              <motion.span
                className="card-gaming"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}   // Anima para ficar visível e na posição original
                transition={{ duration: 0.90, delay: 0.2 }} // Duração e atraso da animação
              >
                <FontAwesomeIcon icon={faTrophy} className="gamification-icon me-2" />
                {ranking && (
                  <Card.Text>
                    {ranking.percentualTop === 0 && !isRanking
                      ? "Você ainda não está no ranking"
                      : `Top ${Math.round(rankingTop)}%`}
                  </Card.Text>
                )}
              </motion.span>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default CardInfo;
